module.exports = new __parcel__URL__("goblin-camp.6efcfb77.webp").toString();